"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _nodeIds = require("../../constants/nodeIds");

var StepperOutlet = function StepperOutlet(boxProps) {
  return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({}, boxProps, {
    id: _nodeIds.STEPPER_OUTLET_ID
  }));
};

var _default = StepperOutlet;
exports.default = _default;